import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBullet = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18 16l-8 1-4-6 5-4 7 1z" })
});
export default SvgBullet;
